module.exports = __webpack_public_path__ + "static/media/3.672d6718.jpg";